const Divider = () => <hr className="tw-w-full tw-border-neutral-gray-10 tw-my-0" />;

export default Divider;
